import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
@Input() type: 'success' | 'error' | 'info' | 'warn' | 'warning' = 'info';
  @Input() message: string = '';
  @Output() dismiss = new EventEmitter<void>();

  get formattedMessage(): string {
    return this.message?.replace(/\\n/g, '\n') ?? '';
  }

  close() {
    this.dismiss.emit();
  }
}
